export enum BrandColorCategory {
  Options = 1,
  Matrix  = 2,
  Ranking = 3,
}